import { render, staticRenderFns } from "./ClubsHeader.vue?vue&type=template&id=a4f2bb78"
import script from "./ClubsHeader.vue?vue&type=script&lang=js"
export * from "./ClubsHeader.vue?vue&type=script&lang=js"
import style0 from "./ClubsHeader.vue?vue&type=style&index=0&id=a4f2bb78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports